import { render, staticRenderFns } from "./freightProduct.vue?vue&type=template&id=8355ac22&scoped=true&"
import script from "./freightProduct.vue?vue&type=script&lang=ts&"
export * from "./freightProduct.vue?vue&type=script&lang=ts&"
import style0 from "./freightProduct.vue?vue&type=style&index=0&id=8355ac22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8355ac22",
  null
  
)

export default component.exports